export default __webpack_public_path__ + "static/media/6.LINEAS_DE_PRODUCCION.5b304b5d.jpg";